/**
 * Created by tomers on 8/24/2016.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");

    var AgentGroupUtilities = (function () {

        var reverseTree = function(collection) {
            _.each(collection.models, function(model) {
                var parentGroupId = model.get("parentGroupId");
                if(parentGroupId) {
                    var parentGroupModel = collection.get(parentGroupId);
                    if(!parentGroupModel.children) {
                        parentGroupModel.children = [];
                    }
                    parentGroupModel.children.push(model.get("id"));
                }
            });
        };

        var findTreeAgentGroupSelected = function(collection, arr, id) {
            var modelById = collection.get(id);
            if(modelById) {
                arr.push(modelById);
                _.each(modelById.children, function(child) {
                    findTreeAgentGroupSelected(collection, arr, child);
                });
            }
        };

        var removeTreeAgentGroupSelected = function(collection, id) {
            reverseTree(collection);
            var arrRemoveTreeAgentGroupSelected = [];
            findTreeAgentGroupSelected(collection, arrRemoveTreeAgentGroupSelected, id);
            _.each(arrRemoveTreeAgentGroupSelected, function(model) {
                collection.remove(model);
            });
        };

        return {
            removeTreeAgentGroupSelected: removeTreeAgentGroupSelected
        };

    })();
    return AgentGroupUtilities;

});
